import { Route } from "react-router-dom";
import ReservationsDetailReportScreen from "../../../container/Reservations/ReservationsDetailReportScreen";
import CreateReservationsDetailReport from "../../../container/Reservations/ReservationsDetailReportScreen/CreateReservationsDetailReport";
import { APP_URLS } from "../../../utils/constant";

const ReservationsDetailReportRoutes = (access = {}) => {
  const { create, view, edit = false } = access;
console.log('access',access)
  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.RESERVATIONS_DETAILREPORT.HOME}
          element={
            <ReservationsDetailReportScreen screenPermissions={access} />
          }
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.RESERVATIONS_DETAILREPORT.CREATE}
          element={<CreateReservationsDetailReport />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.RESERVATIONS_DETAILREPORT.EDIT}
          element={<CreateReservationsDetailReport isEdit={true} />}
        />
      )}
    </>
  );
};

export default ReservationsDetailReportRoutes;
